const RoutingPage = () => {

    return (
        <>Router 테스트 페이지입니다.</>
    );
}


export default RoutingPage;